import React, { useState } from "react";
import useStore from "../../../../../context/useStore";
import useRole from "../../../../../hooks/useRole/useRole";
import useClientFilters from "./useClientFilters";
import { CHAMPS_LIES_AU_CONTRAT, estSansFiche } from "./clientFilterRules";
import { CLIENT_PRESETS, SEARCH_SCOPES, quickContractStatuses, scopeActif } from "./clientPresets";

// Barre repliée : segment « Statut du contrat », recherche à portée choisie,
// bouton « Filtres » avec badge, « Rechercher », puis les vues rapides.
const ClientQuickFilterBar = ({ showAdvanced, onToggleAdvanced, activeFilterCount, isLoading }) => {
  const [state] = useStore();
  const { myRole } = useRole();
  const { POLICIES_STATUS } = state.constants.items;
  const { filtres, actions } = useClientFilters();
  const [scopeChoisi, setScopeChoisi] = useState(null);

  const sansFiche = estSansFiche(filtres);
  // Un client sans fiche n'a ni société ni contrat : ces portées disparaissent.
  const scopes = sansFiche
    ? SEARCH_SCOPES.filter((s) => !CHAMPS_LIES_AU_CONTRAT.includes(s.id))
    : SEARCH_SCOPES;
  const scope =
    scopes.find((s) => s.id === scopeActif(filtres, scopeChoisi)) || scopes[0];

  const statuts = quickContractStatuses(POLICIES_STATUS);
  const statutActif = (id) => filtres.statutContrat !== "" && Number(filtres.statutContrat) === id;
  // Clic = ce statut + recherche ; re-clic sur l'actif = tous les statuts.
  const onStatut = (id) => actions.applyAndSearch({ statutContrat: statutActif(id) ? "" : id });

  const presetCtx = { myRole };
  const presets = CLIENT_PRESETS.filter((p) => p.isAvailable(presetCtx));

  return (
    <>
      <div className="lf-toolbar">
        {statuts.length > 0 && (
          <div className="lf-seg" role="group" aria-label="Statut du contrat">
            {statuts.map((s) => (
              <button
                key={s.id}
                type="button"
                className={statutActif(s.id) ? "lf-on" : ""}
                aria-pressed={statutActif(s.id)}
                disabled={sansFiche}
                onClick={() => onStatut(s.id)}
              >
                <i className={`fa ${s.icon}`} aria-hidden="true" />
                {s.label}
              </button>
            ))}
          </div>
        )}

        <div className="lf-search">
          <i className="fa fa-search" aria-hidden="true" />
          <select
            className="lf-scope"
            aria-label="Champ de recherche"
            value={scope.id}
            onChange={(e) => setScopeChoisi(e.target.value)}
          >
            {scopes.map((s) => (
              <option key={s.id} value={s.id}>
                {s.label}
              </option>
            ))}
          </select>
          <input
            type="text"
            value={filtres[scope.id]}
            placeholder={scope.placeholder}
            aria-label={`Rechercher par ${scope.label}`}
            onChange={(e) =>
              actions.updateFilter(scope.id, scope.normaliser ? scope.normaliser(e.target.value) : e.target.value)
            }
          />
        </div>

        <button
          type="button"
          className={"lf-btn lf-btn-ghost" + (activeFilterCount > 0 ? " lf-badge-on" : "")}
          onClick={onToggleAdvanced}
          aria-expanded={showAdvanced}
        >
          <i className="fa fa-sliders" aria-hidden="true" />
          Filtres
          {activeFilterCount > 0 && <span className="lf-count">{activeFilterCount}</span>}
        </button>

        <button type="submit" className="lf-btn lf-btn-primary" disabled={isLoading}>
          <i className={isLoading ? "fa fa-spinner fa-spin" : "fa fa-search"} aria-hidden="true" />
          Rechercher
        </button>
      </div>

      {presets.length > 0 && (
        <div className="lf-presets">
          <span className="lf-lbl">Vues rapides</span>
          {presets.map((preset) => {
            const on = actions.isPresetOn(preset, presetCtx);
            return (
              <button
                key={preset.id}
                type="button"
                className={"lf-chip" + (on ? " lf-on" : "")}
                aria-pressed={on}
                onClick={() => actions.applyPreset(preset, presetCtx)}
              >
                <i className={`fa ${preset.icon}`} aria-hidden="true" />
                {preset.label}
              </button>
            );
          })}
        </div>
      )}
    </>
  );
};

export default ClientQuickFilterBar;
